import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {StockCostingType} from "../stock-costing-type";
import {AbstractHeaderComponent} from "../../../framework/entity/grid/abstract-header.component";
import {debounceTime, Subject, Subscription} from "rxjs";
import {FUIFormContext, FUIHeaderFormContext} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-stock-costing-header",
    styleUrls: ["./stock-costing-header.component.scss"],
    templateUrl: "./stock-costing-header.component.html",
    providers: [{provide: FUIFormContext, useClass: FUIHeaderFormContext}],
})
export class StockCostingHeaderComponent extends AbstractHeaderComponent implements OnInit, OnDestroy {
    StockCostingType = StockCostingType;

    @Input() allowCustomCost: boolean = false;
    @Output() detailsChange: EventEmitter<void> = new EventEmitter<void>();
    @Output() costingTypeChange: EventEmitter<StockCostingType> = new EventEmitter<StockCostingType>();
    @Output() customCostChange: EventEmitter<number> = new EventEmitter<number>();
    @Output() outletIdChange: EventEmitter<number> = new EventEmitter<number>();

    private _costingType: StockCostingType;
    private _customCost: number;
    private _outletId: number;
    private customCostSubject: Subject<number> = new Subject<number>();
    private customCostSubscription: Subscription;

    constructor() {
        super();
        this.customCostSubscription = this.customCostSubject.pipe(debounceTime(1000)).subscribe((customCost: number) => this.detailsChange.emit())
    }

    ngOnInit(): void {
        this.costingType = StockCostingType.LAST_COST;
    }

    ngOnDestroy(): void {
        this.customCostSubscription.unsubscribe();
    }

    get costingType(): StockCostingType {
        return this._costingType;
    }

    @Input() set costingType(costingType: StockCostingType) {
        if (costingType !== undefined && costingType !== this._costingType) {
            this._costingType = costingType;
            this.costingTypeChange.emit(costingType);
            this.detailsChange.emit();
        }
    }

    get customCost(): number {
        return this._customCost;
    }

    @Input() set customCost(customCost: number) {
        if (customCost !== this._customCost) {
            this._customCost = customCost;
            this.customCostChange.emit(customCost);
            this.customCostSubject.next(customCost);
        }
    }

    get outletId(): number {
        return this._outletId;
    }

    @Input() set outletId(outletId: number) {
        if (outletId !== this._outletId) {
            this._outletId = outletId;
            this.outletIdChange.emit(outletId);
            this.detailsChange.emit();
        }
    }
}
